import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import {
  Box,
  Button,
  Stack,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { Form, Link, useLoaderData, useParams } from "react-router-dom";
import { Result } from "../../types/Result";
import { Chat } from "./type";

export default function ChatForm() {
  const params = useParams();
  const data = useLoaderData() as Result<Chat>;

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "800px" } }}>
      {data.data && (
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: "center", justifyContent: "space-between", mb: 1 }}
        >
          <Link to={`/users/${data.data.creatorId}`}>{data.data.fullName}</Link>
          <Button
            component={Link}
            to={`/chats/conversation/${data.data.hospitalId}?focus=${data.data.id}`}
            size="small"
            variant="outlined"
            startIcon={<ForumOutlinedIcon />}
          >
            Yazışmaya git
          </Button>
        </Stack>
      )}
      <Form method="post">
        {/* Referans Chat Bilgisi */}
        {data.data?.refChat && (
          <Card sx={{ mb: 2, bgcolor: "grey.50" }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Referans Chat
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Kimden:</strong> {data.data.refChat.fullName}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Mesaj:</strong> {data.data.refChat.message}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Hastane:</strong>{" "}
                {data.data.refChat.hospital?.hospitalName}
              </Typography>
            </CardContent>
          </Card>
        )}

        <TextField
          placeholder="Referans Chat ID"
          type="text"
          name="refChatId"
          defaultValue={data.data?.refChatId || ""}
          fullWidth
          margin="dense"
          label="Referans Chat ID"
          disabled={params.id !== "new"}
          required
        />

        <TextField
          required
          placeholder="Ad Soyad"
          type="text"
          name="fullName"
          defaultValue={data.data?.fullName || ""}
          fullWidth
          margin="dense"
          label="Ad Soyad"
        />

        <TextField
          required
          placeholder="Mesaj"
          type="text"
          name="message"
          defaultValue={data.data?.message || ""}
          fullWidth
          margin="dense"
          label="Mesaj"
          multiline
          rows={4}
        />

        <FormControl fullWidth margin="dense">
          <InputLabel>Hastane</InputLabel>
          <Select
            name="hospitalId"
            defaultValue={data.data?.hospitalId || ""}
            label="Hastane"
            required
          >
            {/* Hastane listesi buraya gelecek */}
            {data.data?.hospital && (
              <MenuItem value={data.data.hospital.id}>
                {data.data.hospital.hospitalName}
              </MenuItem>
            )}
          </Select>
        </FormControl>

        {/* Action field to distinguish between save and delete */}
        <input type="hidden" name="action" value="save" id="actionField" />

        {/* Delete Button - Only show if not creating new */}
        {params.id !== "new" && (
          <Button
            fullWidth
            color="error"
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={(e) => {
              if (
                window.confirm("Bu chat'i silmek istediğinizden emin misiniz?")
              ) {
                const actionField = document.getElementById(
                  "actionField",
                ) as HTMLInputElement;
                if (actionField) actionField.value = "delete";
              } else {
                e.preventDefault();
              }
            }}
            type="submit"
          >
            Sil
          </Button>
        )}

        <Button
          fullWidth
          type="submit"
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => {
            const actionField = document.getElementById(
              "actionField",
            ) as HTMLInputElement;
            if (actionField) actionField.value = "save";
          }}
        >
          Kaydet
        </Button>
      </Form>
    </Box>
  );
}
